import React, { useEffect, useMemo, useState } from 'react';
import api from '../../lib/api';
import StreamingChat from '../StreamingChat';

const SUGGESTIONS = [
  'Summarize the ATDE architecture in 3 paragraphs',
  'List every API route under /learning',
  'Explain how the Truth System resolves conflicts',
  'Plan a feature: add an Options Flow panel',
  'What changed in the last 7 days?',
  'Where is the rollback script and how does it work?',
];

/**
 * LabAssistant — engineering chat surface backed by /api/lab/chat/stream.
 * Reuses the shared <StreamingChat /> component so behavior matches the
 * global ChatWidget exactly (and future Planner/CodeGen surfaces too).
 */
export default function LabAssistant({ token }) {
  const sessionId = useMemo(() => `lab-${new Date().toISOString().slice(0, 10)}`, []);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get(`/lab/chat/history?session_id=${sessionId}`)
      .then(({ data }) => setHistory(data.messages || []))
      .catch(() => {});
  }, [sessionId]);

  return (
    <div data-testid="lab-assistant" className="space-y-2">
      <div className="text-[10px] tracking-[0.25em] uppercase text-[var(--txt-secondary)]">
        Lab Assistant streams answers grounded in the live architecture index + engineering memory.
        It will NOT write code until the Code Generator phase ships.
      </div>
      <StreamingChat
        kind="lab"
        sessionId={sessionId}
        token={token}
        initialMessages={history}
        suggestions={SUGGESTIONS}
        placeholder="Ask about ATDE architecture, plan a feature, audit a system..."
        testIdPrefix="lab-assistant"
        minHeight="60vh"
      />
    </div>
  );
}
